module.exports = __webpack_public_path__ + "static/img/zhong3.3f104d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong3.png
// module id = HZyM
// module chunks = 16